module.exports = __webpack_public_path__ + "static/media/ai-agent.28804251.svg";